import UnderlinedText from "./underlined_text";
import { Grid, Typography } from "@mui/material";
import { fieldHeader } from "../../../../components/fields/field_header";

const ViewInsuranceInformation = ({ data }: any) => {
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h6" color={"white"} bgcolor={"red"} p={0.5}>
          INSURANCE INFORMATION:
          <Typography variant="body2">
            (Please make sure that IGA, Inc. is added as an additional insured
            on your comprehensive general liability insurance policy and provide
            proof of insurance to IGA.)
          </Typography>
        </Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("Agent Name", false)}</Grid>
        <UnderlinedText text={data.insuranceAgentName} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("Insurance Co. Name", false)}</Grid>
        <UnderlinedText text={data.insuranceCompanyName} />
      </Grid>
      <Grid item xs={12}>
        <Grid item>{fieldHeader("Insurance Address", false)}</Grid>
        <UnderlinedText text={data.insuranceAddress} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Insurance City", false)}</Grid>
        <UnderlinedText text={data.insuranceCity} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Insurance State", false)}</Grid>
        <UnderlinedText text={data.insuranceState} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Insurance ZIP", false)}</Grid>
        <UnderlinedText text={data.insuranceZip} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("Insurance Phone", false)}</Grid>
        <UnderlinedText text={data.insurancePhone} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("Insurance Email Address", false)}</Grid>
        <UnderlinedText text={data.insuranceEmail} />
      </Grid>
    </>
  );
};

export default ViewInsuranceInformation;
